import _ from 'lodash';
//constants
import { field } from '../types';
import { FormControl, TextField } from '@mui/material';
import { getErrorText } from '..';
import { CustomTextArea } from 'theme/elements/Inputs';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

type props = {
	valid: boolean;
	cField: field;
	initialValidation: any;
	handleChange: any;
	maxLength?: number;
	minLength?: number;
};

export default function TextArea(props: props) {
	const t = useAppSelector(selectTranslations);
	const { valid, cField, handleChange, initialValidation } = props;
	const { name, value, helperText, maxLength = 450, minLength = 0 } = cField.props;

	return (
		<CustomTextArea key={name} sx={{ display: 'flex', alignItems: 'baseline!important' }}>
			<FormControl fullWidth>
				<TextField
					multiline
					inputProps={{ maxLength, minLength }}
					error={!valid}
					{...cField.props}
					helperText={valid ? helperText : t(getErrorText(props.initialValidation, name))}
					value={['null', 'undefined'].includes(typeof value) ? '' : value}
					onChange={props.handleChange}
					variant="filled"
					autoComplete="off"
				/>
			</FormControl>
		</CustomTextArea>
	);
}
